
import { Helmet } from "react-helmet";

const Meta = ({ title, description, keywords, image, url }) => {
    const defaultTitle = "THE CUTTING BAR"; 
    const defaultDescription = "Your appearance plays a very important role in today’s lifestyle. We provide personal fitness services in Rajkot, including high-quality salon services.";
    const defaultKeywords = "Best salons in Rajkot, Salons in Rajkot";
    const defaultImage = "https://thecuttingbar.in/themes/images/The_cutting_bar2.png";
    const defaultUrl = "https://thecuttingbar.in";

    return (
        <Helmet>
            <title>{title || defaultTitle}</title>
            <meta property="og:title" content={title || defaultTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            <meta property="og:image" content={image || defaultImage} />
            <meta property="og:url" content={url || defaultUrl} />
            <meta name="keywords" content={keywords || defaultKeywords} />
        </Helmet>
    );
};

export default Meta;
